<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../../helpers/interface_helpers';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	//Services
	import { postReq } from '../../../../../services/http';
	//Design system components
	import { Text, Select } from '@Shelly/shelly-design-system';
	import type { SelectOptionPropsType } from '@Shelly/shelly-design-system';

	//Types
	import type { Request } from '../../../../../types/requests/request';
	import type { Device } from '../../../../../types/Device';
	export let disabled: boolean;
	export let device: Device;
	export const save = async (): Promise<Request> => {
		if (value == settings.operating_mode) return { isok: true };
		return await postReq(
			`/device/generic_command`,
			{
				id,
				command: 'motion_operating_mode',
				payload: JSON.stringify({ value: Number(value) }),
			},
			10000,
		);
	};

	let selectIcon = {
		0: 'fa-solid fa-moon-over-sun',
		1: 'fas fa-moon',
		2: 'fa-solid fa-sun-haze',
		3: 'fa-solid fa-sun',
	};

	const options: SelectOptionPropsType[] = [
			{
				title: $format('option_motion_mode_any', { default: 'Any' }),
				value: 0,
			},
			{
				title: $format('option_motion_mode_dark', { default: 'Dark' }),
				value: 1,
			},
			{
				title: $format('option_motion_mode_twilight', { default: 'Twilight' }),
				value: 2,
			},
			{
				title: $format('option_motion_mode_bright', { default: 'Bright' }),
				value: 3,
			},
		],
		id = real_id(device.id),
		settings = readDeviceSettings(id)?.motion;

	let value = settings.operating_mode;
</script>

<Text
	styleType="body-small"
	class={classMap({
		'mb-xs': true,
		'text-color-3': disabled,
	})}
>
	{$format('motion_mode_description', {
		default: 'Select sensors operating mode:',
	})}
</Text>

<Select
	class="mb-m"
	value={options.find((i) => i.value == value)}
	{options}
	{disabled}
	icon={selectIcon[value]}
	on:change={(e) => {
		value = e.detail['value'];
	}}
	id="select-4j0irbb"
	aria-label={$format('motion_mode_description', {
		default: 'Select sensors operating mode',
	})}
/>
